import React from "react";
import { CallToActionProps } from "../../interfaces/interfaces.d";
import { WrapperMain } from "./Main.styles";
import { CallToActionCard } from "../cards/callToActionCard/CallToActionCard";
import { callToActionData } from "../../data/callToActionData";
import { mainColor } from "../../styles/global";

export const CallToAction = () => {
  return (
    <>
      <WrapperMain>
        <div
          style={{
            background: `${mainColor}`,
            maxWidth: "700px",
            borderRadius: "20px",
          }}
        >
          <img src="img/Group 8589.svg" alt="" />
        </div>
        {callToActionData.map((data: CallToActionProps, index: number) => (
          <CallToActionCard
            key={index}
            image={data.image}
            icon={data.icon}
            title={data.title}
            text={data.text}
            linkText={data.linkText}
            linkUrl={data.linkUrl}
          />
        ))}
      </WrapperMain>
    </>
  );
};
